import { render, staticRenderFns } from "./ProgramDetailsLearningCard.vue?vue&type=template&id=3514a582&scoped=true"
import script from "./ProgramDetailsLearningCard.vue?vue&type=script&lang=js"
export * from "./ProgramDetailsLearningCard.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetailsLearningCard.vue?vue&type=style&index=0&id=3514a582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3514a582",
  null
  
)

export default component.exports